<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.ComponentTypeFilter.label')"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <div class="filter__summary text--disabled">
        <div class="filter__icon">
          <img
            alt="icon"
            :src="loadImageSource(false, item.value)"
          >
        </div>
        {{ item.text }}
      </div>
    </template>

    <template v-slot:item="{item, attrs}">
      <div class="filter__icon">
        <img
          alt="icon"
          :src="loadImageSource(attrs.inputValue, item.value)"
        >
      </div>
      {{ item.text }}
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';
import { COMPONENT_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'ComponentTypeFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    selectItems() {
      const allChartsType = [{
        text: this.$t('components.filters.ComponentTypeFilter.items.line'),
        value: COMPONENT_TYPE.LINE,
        show: true,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.stackedLine'),
        value: COMPONENT_TYPE.STACKED_LINE,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.column'),
        value: COMPONENT_TYPE.VERTICAL_BAR,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.stackedColumn'),
        value: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.bar'),
        value: COMPONENT_TYPE.HORIZONTAL_BAR,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.stackedBar'),
        value: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.donut'),
        value: COMPONENT_TYPE.DONUT,
        show: true,
      },
      {
        text: this.$t('components.filters.ComponentTypeFilter.items.number'),
        value: COMPONENT_TYPE.SINGLE_VALUE,
        show: true,
      }];

      return allChartsType.filter(chart => chart.show);
    },
  },
  methods: {
    loadImageSource(inputValue = false, componentType) {
      const source = inputValue ? `selected/${componentType}` : componentType;

      return require(`@/assets/icons/${source}.svg`);
    },
  },
};

</script>

<style scoped lang="scss">
.filter {
  &__summary {
    margin-top: var(--ds-spacing-inline-quark);
    margin-left: var(--ds-spacing-inline-nano);
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__icon {
    margin: calc(var(--ds-spacing-inline-quark) / 2) var(--ds-spacing-inline-nano) 0 0;
  }
}
</style>
